import React, { useState } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import { MuiBox, MuiTypography } from "components/atoms";
import { useTranslation } from "react-i18next";

//SVGs
import DownArrow from "assets/images/svg-icons/chevron-down.svg";

const GeneralAccessMenu = ({
  generalAccessType = "restricted",
  setGeneralAccessType,
  isDisable = false,
}) => {
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);

  const open = Boolean(anchorEl);

  const menuItems = [
    { label: "modal.shareFileFolder.restricted", value: "restricted" },
    { label: "modal.shareFileFolder.anyoneWithTheLink", value: "public" },
  ].filter(Boolean);

  const showDefaultType = {
    restricted: "modal.shareFileFolder.restricted",
    public: "modal.shareFileFolder.anyoneWithTheLink",
  };

  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => setAnchorEl(null);

  const handleChange = (value) => {
    setGeneralAccessType(value);
    handleClose();
  };

  return (
    <>
      <Button
        disabled={isDisable}
        endIcon={
          <MuiBox sx={{ height: "20px", width: "20px", display: "flex" }}>
            <img src={DownArrow} alt="" className="img-full" />
          </MuiBox>
        }
        sx={{
          p: "8px",
          color: "text.darkBlack",
          borderRadius: "8px",
          width: "fit-content",
          minWidth: "100px",
          flexShrink: 0,
          justifyContent: "space-between",
          "&.Mui-disabled": {
            color: "#8b8b8b !important",
            backgroundColor: "transparent !important",
          },
        }}
        onClick={handleOpen}
      >
        {t(showDefaultType[generalAccessType])}
      </Button>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          disablePadding: true,
        }}
        slotProps={{
          paper: {
            sx: {
              mt: "8px",
              p: "8px",
              boxShadow: "0px 6px 24px 0px #0000000D",
              borderRadius: "8px",
              border: "1px solid",
              borderColor: "background.gray400",
            },
          },
        }}
      >
        {menuItems?.map((item) => (
          <MenuItem
            key={item?.value}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
              my: "1px",
              borderRadius: "8px",
              backgroundColor:
                item?.value === generalAccessType
                  ? "background.blue200"
                  : "none",
            }}
            onClick={() => handleChange(item?.value)}
          >
            {/* <MuiBox sx={{ height: "20px", width: "20px" }}>
              <img src={item?.icon} alt="" className="img-contain" />
            </MuiBox> */}
            <MuiTypography fontWeight="500" variant="14" color="text.darkBlack">
              {t(item?.label)}
            </MuiTypography>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default GeneralAccessMenu;
